export default __webpack_public_path__ + "static/media/background-splash-middle.a137e56b.svg";